class CategoryGridToggle {
  constructor(sectionId) {
    this.grid = document.getElementById(`category-grid-${sectionId}`);
    if (!this.grid) return;

    this.toggleBtn = this.grid.parentElement.querySelector('[data-category-toggle]');
    if (!this.toggleBtn) return;

    this.label = this.toggleBtn.querySelector('[data-toggle-label]');
    this.items = Array.from(this.grid.querySelectorAll('.category-grid__item'));
    this.visibleCount = parseInt(this.grid.getAttribute('data-visible-count'), 10) || this.items.length;
    this.isExpanded = false;

    this.toggleBtn.addEventListener('click', () => this.toggle());

    // Recompute the collapsed height on resize/orientation change, since
    // row height can change (e.g. text wrapping differently at other widths).
    window.addEventListener('resize', () => this.updateCollapsedHeight());

    // Measure after images/fonts settle, not just DOMContentLoaded, so the
    // measured row height is accurate (icons can shift layout once loaded).
    window.addEventListener('load', () => this.updateCollapsedHeight());
    this.updateCollapsedHeight();
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  updateCollapsedHeight() {
    if (!this.isMobile() || this.isExpanded) return;

    if (this.items.length <= this.visibleCount) {
      // Nothing to hide — make sure no leftover height cap is applied.
      this.grid.classList.remove('is-collapsible');
      this.grid.style.maxHeight = '';
      return;
    }

    const lastVisibleItem = this.items[this.visibleCount - 1];
    if (!lastVisibleItem) return;

    const gridRect = this.grid.getBoundingClientRect();
    const itemRect = lastVisibleItem.getBoundingClientRect();
    const gridStyle = window.getComputedStyle(this.grid);
    const paddingBottom = parseFloat(gridStyle.paddingBottom) || 0;

    const collapsedHeight = Math.ceil(itemRect.bottom - gridRect.top + paddingBottom);

    this.grid.classList.add('is-collapsible');
    this.grid.style.maxHeight = `${collapsedHeight}px`;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.grid.classList.toggle('is-expanded', this.isExpanded);
    this.toggleBtn.setAttribute('aria-expanded', this.isExpanded ? 'true' : 'false');

    if (this.label) {
      this.label.textContent = this.isExpanded ? 'View Less' : 'View All';
    }

    if (this.isExpanded) {
      this.grid.style.maxHeight = '';
    } else {
      this.updateCollapsedHeight();
      this.grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

window.CategoryGridToggle = CategoryGridToggle;
